<template>
    <section class="search" :class="{'is-active': isActive, 'no-transition': noTransition}">
        <div class="search__wrapper" ref="search">
            <section class="search__inner" ref="inner">
                <section class="search__header container">
                    <p class="search__header__instructions"> start typing to search</p>
                    <div v-if="isMobile" @click="onClickClose" class="search__header__close--icon"></div>
                    <a v-else @click="onClickClose" class="search__header__close link"> close</a>
                </section>
                <div class="search__elem container">
                    <div class="search__elem__inner">
                        <span class="search__suggestion" v-show="currentSuggestion">{{ currentSuggestion }}</span>
                        <input type="text" class="search__input" placeholder="search" aria-label="search field" ref="input" @keyup="onKeyUp">
                    </div>
                </div>
                <div class="search__results container">
                    <AppLoader :grey="true" ref="loader"/>
                    <template v-for="(item, index) in results">
                        <router-link v-if="item.post.post_type === 'news'" :to="`/articles/${item.post.ID}`" class="search__result" :key="index">
                            <img class="search__result__img" :src="item.acf.preview_image.url" :alt="item.acf.preview_image.alt">
                            <div class="search__result__content">
                                <p class="search__result__type">{{ item.post.post_type }}</p>
                                <p class="search__result__title" v-html="item.acf.displayed_title"></p>
                            </div>
                        </router-link>
                        <router-link v-if="item.post.post_type === 'products'" :to="`/product/${item.post.ID}`" class="search__result" :key="index">
                            <img class="search__result__img" :src="item.acf.preview_image.url" :alt="item.acf.preview_image.alt">
                            <div class="search__result__content">
                                <p class="search__result__type">{{ item.post.post_type }}</p>
                                <p class="search__result__title" v-html="item.acf.title"></p>
                            </div>
                        </router-link>
                        <router-link v-if="item.post.post_type === 'warriors'" :to="`/warriors/${item.post.ID}`" class="search__result" :key="index">
                            <img class="search__result__img" :src="item.acf.cover_image.url" :alt="item.acf.cover_image.alt">
                            <div class="search__result__content">
                                <p class="search__result__type">{{ item.post.post_type }}</p>
                                <p class="search__result__title" v-html="item.acf.displayed_title"></p>
                            </div>
                        </router-link>
                    </template>
                    <template v-for="(item, index) in tagsResults">
                        <router-link :to="`/product/${item.id}`" class="search__result" :key="index">
                            <img class="search__result__img" :src="item.acf.preview_image.url" :alt="item.acf.preview_image.alt">
                            <div class="search__result__content">
                                <p class="search__result__type">products</p>
                                <p class="search__result__title" v-html="item.acf.title"></p>
                            </div>
                        </router-link>
                    </template>
                </div>
            </section>
        </div>
    </section>
</template>
<script>
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import EventHub from '@/utils/EventHub'
import AppLoader from '@/components/AppLoader'

export default {
    name: 'Search',

    components: {
        AppLoader
    },

    data() {
        return {
            isActive: false,
            isMobile: false,
            noTransition: false,
            results: null,
            tagsResults: null,
            currentSuggestion: ''
        }
    },

    created()
    {
        this.tags = []
        this.currentTagsPage = 1
        this.timer = null
        this.elemHeight = 0
        this.addListeners()
        this.loadTags()
    },

    destroyed()
    {
        this.removeListeners()
        clearAllBodyScrollLocks()
    },

    methods: {
        addListeners()
        {
            EventHub.$on('application:toggle-search', this.onToggleSearch)
            EventHub.$on('application:toggle-tags-search', this.onToggleTagsSearch)
            EventHub.$on('application:on-route-change', this.onRouteChange)
            EventHub.$on('application:ask-for-tags', this.onAskForTags)
            EventHub.$on('window:resize', this.onResize)
        },

        removeListeners()
        {
            EventHub.$off('application:toggle-search', this.onToggleSearch)
            EventHub.$off('application:toggle-tags-search', this.onToggleTagsSearch)
            EventHub.$off('application:on-route-change', this.onRouteChange)
            EventHub.$off('application:ask-for-tags', this.onAskForTags)
            EventHub.$off('window:resize', this.onResize)
        },

        loadTags()
        {
            const url = process.env.VUE_APP_WP_API + `/wp-json/wp/v2/tags?per_page=100&page=${this.currentTagsPage}`

            fetch(url)
                .then((res) => res.json())
                .then((res) =>
                {
                    this.tags = this.tags.concat(res)
                    this.searchList = []

                    for(let i = 0; i < this.tags.length; i++)
                    {
                        this.searchList.push(this.tags[i].name.toLowerCase())
                    }

                    if(res.length === 100)
                    {
                        // Load another 100 tags
                        this.currentTagsPage += 1
                        this.loadTags()
                    }
                    else
                    {
                        EventHub.$emit('application:get-all-tags', this.tags)
                    }
                })
        },

        onAskForTags()
        {
            EventHub.$emit('application:get-all-tags', this.tags)
        },

        reinitSearch()
        {
            this.results = []
            this.tagsResults = []
            this.$refs.input.value = ''
            this.currentSuggestion = ''
            enableBodyScroll(this.$refs.search)
        },

        shutSearchTimer()
        {
            clearTimeout(this.timer)
        },

        createSearchTimer()
        {
            this.timer = setTimeout(() => {
                this.proceedSearch()
            }, 1000)
        },

        proceedComplete()
        {
            const word = this.$refs.input.value

            this.currentSuggestion = this.checkSuggestionInTags(word)
        },

        checkSuggestionInTags(word)
        {
            const wLength = word.length
            let suggestion = ''

            if(this.searchList.indexOf(word) === -1)
            {
                const tempo = this.searchList.filter((item) => 
                {
                    return item.substr(0, wLength) === word
                })

                if(tempo.length >= 1)
                {
                    suggestion = tempo[0]
                }

                return suggestion
            }
        },

        proceedSearch()
        {
            this.$refs.loader.enable()
            this.results = []
            this.tagsResults = []

            const word = this.$refs.input.value

            const isTagsSearch = this.checkWordInTags(word)

            if(!isTagsSearch)
            {
                const url = process.env.VUE_APP_WP_API + '/wp-json/dow/v1/search?search=' + word
                fetch(url)
                    .then((res) => res.json())
                    .then((res) =>
                    {
                        this.$refs.loader.disable()

                        if(!(res.message === 'no results'))
                        {
                            this.results = res
                        }
                    })
            }

        },

        checkWordInTags(word)
        {
            for(let i = 0; i < this.tags.length; i++)
            {
                const lWord = word.toLowerCase()
                const lTag = this.tags[i].name.toLowerCase()
                if (lTag.indexOf(lWord) > -1)
                {
                    this.proceedSearchByTag(this.tags[i].id)

                    return true
                } 
            }

            return false
        },

        proceedSearchByTag(id)
        {
            this.tagsResults = []
            this.results = []

            const url = process.env.VUE_APP_WP_API +  `/wp-json/wp/v2/products?tags=${id}`

            fetch(url)
                .then((res) => res.json())
                .then((res) =>
                {
                    this.$refs.loader.disable()

                    if(res.length > 0)
                    {
                        this.tagsResults = res
                    }
                })
        },

        onRouteChange()
        {
            this.noTransition = true
            this.isActive = false
            this.reinitSearch()

            setTimeout(() => {
                this.noTransition = false
            }, 600)
        },

        onToggleSearch(isActive)
        {
            this.isActive = isActive

            if(this.isActive)
            {
                disableBodyScroll(this.$refs.search)
                this.$refs.input.focus()
            }
        },

        onToggleTagsSearch(tag)
        {
            this.onToggleSearch(true)
            this.$refs.input.value = tag.value
            this.proceedSearchByTag(tag.id)

        },

        onClickClose()
        {
            // resize height for clean transition
            this.$refs.inner.style.height = `${this.elemHeight}px`

            this.isActive = false

            // After transition
            setTimeout(() => {
                // reset results and input
                this.reinitSearch()
            }, 600)
        },
        

        onKeyUp(ev)
        {
            if(ev.key === 'Enter' && this.currentSuggestion)
            {
                this.$refs.input.value = this.currentSuggestion
            }

            const val = this.$refs.input.value

            // If timer, shut it down and start new one
            if(this.timer)
            {
                this.shutSearchTimer()
            }

            if(val.length >= 2)
            {
                this.proceedComplete()
            }
            else
            {
                this.currentSuggestion = ''
            }

            if(val.length >= 3)
            {
                this.createSearchTimer()
            }
            else
            {
                this.results = []
                this.tagsResults = []
            }
        },

        onResize(windowObj)
        {
            if(windowObj.width <= 768)
            {
                this.isMobile = true
            }
            else
            {
                this.isMobile = false
            }
            this.elemHeight = windowObj.height
            this.$el.style.height = `${this.elemHeight}px`
        }
    }
}
</script>

<style lang="stylus">
.search
    z-index 6
    position fixed
    pointer-events none
    top 0
    left 0
    width auto
    // height 1000px
    // min-height 100vh

    &.is-active
        overflow-y scroll
        pointer-events all

.search__wrapper
    position relative
    width 100vw
    height 100%
    // min-height 100vh
    overflow hidden
    background $grey
    transform translateY(100%)
    transition transform 0.6s $ease-in-out-circ
    
    .is-active &
        transform translateY(0)
        overflow-y scroll

    .no-transition &
        transition all 0s

.search__inner
    position relative
    // padding-bottom 100px
    // height 100%
    min-height 100%
    width 100vw
    transform translateY(-100%)
    transition transform 0.6s $ease-in-out-circ

    .is-active &
        transform translateY(0)

    .no-transition &
        transition all 0s

.search__header
    // height 90px
    display flex
    padding-left calc(100% / 36 * 3)
    justify-content space-between
    align-items center
    text-transform uppercase
    interpolate('height', 768px, 2560px, 60px, 140px);
    interpolate('font-size', 1600px, 2560px, 20px, 25px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 13px, 20px);

    @media(max-width 768px)
        height auto 
        padding-top 20px
        padding-bottom 20px
        padding-left calc(100% / 16)
    
.search__header__close
    cursor pointer

.search__header__close--icon
    position absolute
    top 25px
    right 0
    // right $space-x-mobile
    height 12px
    width 26px

    &:before, &:after
        content ''
        position absolute
        left 0
        width 100%
        height 2px
        background $black
        top 50%
        transform-origin 50% 50%

    &:before
        transform rotate(45deg) 

    &:after
        transform rotate(-45deg)

.search__elem
    padding-left calc(100% / 36 * 3)
    padding-top 50px

    @media(max-width 768px)
        padding-left calc(100% / 16)
        padding-top 0px

.search__elem__inner
    position relative
    width 100%
    height 100%

.search__input, .search__suggestion
    height 130px
    color $white
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 120px, 172px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 58px, 120px);

    @media(max-width 768px)
        font-size 35px
        height 35px

.search__input
    z-index 2
    position relative

.search__suggestion
    position absolute
    top 0
    left 0
    line-height 130px
    opacity 0.3

    @media(max-width 768px)
        line-height 35px

.search__results
    padding 80px calc(100% / 36 * 3) 0 calc(100% / 36 * 3)
    display flex
    flex-wrap wrap

    @media(max-width 768px)
        padding 50px 0 0 calc(100% / 16)

.search__result
    width calc(100% / 30 * 6)
    margin-right calc(100% / 30 * 2)
    margin-bottom 80px
    display flex
    flex-direction column
    justify-content space-between

    &:nth-child(4n + 1)
        margin-right 0

        @media(max-width 768px)
            margin-right calc(100% / 15)

    @media(max-width 768px)
        width calc(100% / 15 * 7)
        margin-right calc(100% / 15)

        &:nth-child(odd)
            margin-right 0

.search__result__img
    width 100%
    display block

.search__result__content
    margin-top 20px

.search__result__type
    margin-bottom 10px
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 20px, 25px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 13px, 20px);

.search__result__title
    max-width 80%
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 25px, 35px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 15px, 25px);

    @media(max-width 768px)
        max-width 100%
    
</style>